module.exports = __webpack_public_path__ + "5687675d9c8bbf4978a80abf2a60578f.png";